const state = {
    data: {},
    allPhoneClients: [],
    selectedPhoneClient: {},
    clientInAttendance: {}
}

const getters = {
    getPhoneClient(state) {
        return state.data;
    },
    getClientInAttendance(state) {
        return state.clientInAttendance;
    }
}

const actions = {}

const mutations = {
    setPhoneClient(data) {
        let dataEvent = data.split('||');

        state.data = {
            queue: dataEvent[0],
            name: dataEvent[1],
            phone: dataEvent[1],
            type: 'phone'
        }

        return state.data;
    },

    delPhoneClient() {
        state.data = {}
    },

    setClientInAttendance(data) {
        state.clientInAttendance = data
        return state.clientInAttendance;
    },

    delClientInAttendance() {
        state.clientInAttendance = {}
    },

    setChatData(data) {
        let obj = {
            Protocolo: data.protocol,
            phone: data.phone,
            type: 'chat',
            name: data.name,
            queue: data.queue
        };
        
        state.data = obj;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
